export const USER_DETAILS_LABELS = {
  pan: 'PAN',
  name: 'Name',
  dob: 'Date of birth',
  pincode: 'pincode',
};
